<script setup lang="ts">
import {computed} from "vue";
import AdacConfigurator from "@/extension/components/extension-configurators/adac/AdacConfigurator.vue";
import Extension from "@/core/interfaces/extension/Extension";

const props = defineProps<{
    /** The configurator slug declared by the extension. */
    slug: string;
    /** The extension being configured. */
    extension: Extension;
    /** Record that the pharmacy went through the configuration, and say whether it was. */
    configure: () => Promise<boolean>;
}>();

/** The configuration component that matches the slug, or null when none does. */
const configurator = computed(() => {
    switch (props.slug) {
        case 'adac':
            return AdacConfigurator;
        default:
            return null;
    }
});
</script>

<template>
  <component
    :is="configurator"
    v-if="configurator"
    :extension="extension"
    :configure="configure"
  />
</template>
